import UltimatePagination from "../../../partials/layout/PaginationComponent";

import React from "react";
import { Card, Table } from "react-bootstrap";
import { formatDateTime, formatProperCaseWithUnderscores } from "../../../../_metronic";




// export const getTaskStatusClass = (status) => {
//     switch (status) {
//         case "ACCEPTED":
//             return "status-accepted";

//         case "JOB_RESCHEDULED":
//             return "status-rescheduled";

//         case "JOB_SYNC_COMPLETE":
//             return "status-done";

//         case "REJECTED":
//             return "status-rejected";

//         default:
//             return "status-progress";
//     }
// };

export const getTaskStatus = (status) => {
    switch (status) {
        case "ACCEPTED":
            return "Accepted";

        case "JOB_RESCHEDULED":
            return "Rescheduled";

        case "JOB_SYNC_COMPLETE":
            return "Done";

        case "REJECTED":
            return "Rejected";

        default:
            return "In Progress";
    }
};

const TaskList = ({ taskList,
    totalRecords,
    currentPage,
    limit,
    onPageChange }) => {
    return (
        <Card className="dashboard-card">
            <Card.Header className="dashboard-card-header d-flex justify-content-between">
                <span>Window 1 - Task List</span>
            </Card.Header>

            <Card.Body className="p-0">
                <div className="task-list-scroll">
                    <Table
                        responsive
                        hover
                        className="mb-0"
                    >
                        <thead>
                            <tr>
                                <th>Property / PM</th>
                                <th>Job Type</th>
                                <th>Assigned To</th>
                                <th>Status</th>
                                <th>Latest Location / DateTime</th>
                                <th>Sync</th>
                                {/* <th>Time Taken</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {taskList.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div
                                            className="property-name"
                                            title={item.formattedHouseName}
                                        >
                                            {item.formattedHouseName}
                                        </div>

                                        <div className="pm-name">
                                            PM: {item.propertyManagerName || "-"}
                                        </div>
                                    </td>

                                    <td>
                                        {formatProperCaseWithUnderscores(item.jobType)}
                                    </td>

                                    <td>
                                        {item.psName}
                                    </td>

                                    {/* <td>
                                        {formatProperCaseWithUnderscores(item.currentStatus)}
                                    </td> */}

                                    <td>
                                        {getTaskStatus(item.currentStatus)}
                                    </td>

                                    <td>
                                        <div className="task-location-time">
                                            <div className="location-row">
                                                <span
                                                    className="icon-text"
                                                    role="img"
                                                    aria-label="location"
                                                >
                                                    📍
                                                </span>

                                                <span className="location-text">
                                                    {Number(item.latitude).toFixed(4)},{" "}{Number(item.longitude).toFixed(4)}
                                                </span>
                                            </div>

                                            <div className="latest-time-small">
                                                <span
                                                    className="icon-text"
                                                    role="img"
                                                    aria-label="time"
                                                >
                                                    🕒
                                                </span>

                                                <span>
                                                    {formatDateTime(item.latestTime)}
                                                </span>
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        {item.currentStatus.includes(
                                            "JOB_SYNC_COMPLETE"
                                        )
                                            ? "Synced"
                                            : "Not Synced"}
                                    </td>

                                    {/* <td>
                                        {item.timeTaken ||
                                            "-"}
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {totalRecords > limit && (
                        <UltimatePagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalRecords / limit)}
                            onChange={onPageChange}
                        />
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default TaskList;